import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="work-edit"
export default class extends Controller {
  static targets = ["editArea"]
  open() {
    this.editAreaTarget.style.display = "block"
  }

  close() {
    this.editAreaTarget.style.display = "none"
  }
}
